import { Card, RadioChangeEvent, Row } from "antd";
import { useCallback, useState } from "react";
import { PaymentRecord } from "./components/PaymentRecord";
import { Payments } from "./components/Payments";
import { Totals } from "./components/Totals";
import { Header } from "./components/Header";
import "./styles.scss";
import dayjs, { Dayjs } from "dayjs";

type TPaymentHistoryProps = {
  contractId: string;
  accountNumber: number;
  reloadAccount: () => void;
};

export const PaymentHistory = ({
  contractId,
  accountNumber,
  reloadAccount,
}: TPaymentHistoryProps) => {
  const [isTotalsOpen, setIsTotalsOpen] = useState<boolean>(false);

  const [paymentId, setPaymentId] = useState<string | null | undefined>(
    undefined,
  );

  const [range, setRange] = useState<[Dayjs, Dayjs]>([
    dayjs().year(dayjs().year() - 1),
    dayjs(),
  ]);

  const [shouldDataReload, setShouldDataReload] = useState<boolean>(false);

  const [openEditMode, setOpenEditMode] = useState<boolean>(false);

  const [isActionsDisabled, setIsActionsDisabled] = useState<boolean>(false);

  const onAddBtnClick = useCallback(() => {
    setPaymentId(null);
    setOpenEditMode(true);
  }, []);

  const onRadioChange = useCallback((e: RadioChangeEvent) => {
    setIsTotalsOpen(e.target.value === 2);
  }, []);

  const back = useCallback(() => setPaymentId(undefined), []);

  const reloadPaymentsData = useCallback(() => {
    setPaymentId(undefined);
    setShouldDataReload(true);
  }, []);

  return (
    <Row className="h-100 w-100 py-6 px-8 card-table">
      <Card className="w-100 h-100">
        <Header
          contractId={contractId}
          isActionsDisabled={isActionsDisabled}
          isTotalsOpen={isTotalsOpen}
          range={range}
          setRange={setRange}
          onRadioChange={onRadioChange}
          onAdd={onAddBtnClick}
        />
        <Row className="w-100 pt-6 d-block card-table__body">
          {isTotalsOpen ? (
            <Totals contractId={contractId} />
          ) : (
            <Payments
              accountId={contractId}
              setPaymentId={setPaymentId}
              shouldDataReload={shouldDataReload}
              range={range}
              setShouldDataReload={setShouldDataReload}
              setOpenEditMode={setOpenEditMode}
              setIsActionsDisabled={setIsActionsDisabled}
              isActionsDisabled={isActionsDisabled}
              reloadAccount={reloadAccount}
            />
          )}
        </Row>
      </Card>
      {paymentId !== undefined && (
        <PaymentRecord
          accountNumber={accountNumber}
          back={back}
          paymentId={paymentId}
          reloadData={reloadPaymentsData}
          contractId={contractId}
          openEditMode={openEditMode}
          setOpenEditMode={setOpenEditMode}
        />
      )}
    </Row>
  );
};
